<template>
  <div>
    <Header />
    <div class="checkoutContent">
      <h1>下單成功</h1>
      <div class="iconTitle">
        <i class="fas fa-shopping-cart"></i>
        <i class="fas fa-check"></i>
      </div>
      <h3>訂單金額(NT)</h3>
      <h4>$<span>2000</span></h4>
      <h5>2021/06/23 16:12</h5>
      <div style="display: flex;justify-content:center;">
        <router-link to="/index" tag="button">繼續選購</router-link>
        <router-link to="/status" tag="button">訂單狀態</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header.vue';

export default {
  components: {
    Header,
  },
};
</script>

<style>
</style>
